/* istanbul ignore file */
import { Route, AppId, createPageRoute } from '@lumapps/router';

export const adminMobileCustomizationRoute: Route = createPageRoute({
    slug: 'mobile/customization',
    appId: AppId.backOffice,
});
